import { ChangeDetectorRef, Component, ElementRef, ViewChild, Input } from '@angular/core';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
import { catchError, of } from 'rxjs';
import { LookupService } from 'src/app/demo/service/lookup.service';

@Component({
  selector: 'app-revenue',
  templateUrl: './revenue.component.html',
  styleUrls: ['./revenue.component.scss']
})
export class RevenueComponent {
  @Input() schoolId!: number;
  @ViewChild('chart') chartRef!: ElementRef;
  chartOptions: any;
  chartData: any;
  selectedYear: number = new Date().getFullYear();
  yearOptions!: any;
  totalRevenue = 0;

  constructor(
    private cdr: ChangeDetectorRef,
    private lookupService: LookupService,
    private webStorage: WebStorage
  ) {}
// changes start
  ngOnInit(): void {
    this.yearOptions = new Date(this.selectedYear, 0); 
    this.initChart();
    // Always use login user's schoolId
    const loginUser = this.webStorage.getUserData();
    if (loginUser && loginUser.schoolId) {
      this.schoolId = loginUser.schoolId;
      this.fetchAddressAndRevenue();
    } else {
      console.warn('No schoolId found in login user data.');
    }
  }

  fetchAddressAndRevenue(): void {
    // Always use this.schoolId for revenue API
    const addressParams = {
      'schoolId.equals': this.schoolId,
      'refTableId.equals': this.schoolId,
      'refTable.equals': 'School',
      'sort': 'id,desc',
      'page': 0,
      'size': 100
    };
    this.lookupService.queryAddress(addressParams).pipe(
      catchError(err => {
        console.error('Address API Error:', err);
        return of(null);
      })
    ).subscribe({
      next: (res: any) => {
        // You can use addressId for other logic if needed
        this.fetchRevenueChart();
      },
      error: (err: any) => {
        console.error('Failed to load address:', err);
      }
    });
  }
// chnages end
  fetchRevenueChart(): void {
    const payload = { year: this.selectedYear };
    this.lookupService.queryRevenu(this.schoolId, payload).pipe(
      catchError(err => {
        console.error('API Error:', err);
        return of(null);
      })
    ).subscribe({
      next: (res: any) => {
        const response = res?.body || {};
        if (response?.monthlyRevenue) {
          const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ];
          const revenueData = months.map(month => response?.monthlyRevenue[month] || 0);
          this.totalRevenue = response.totalRevenue || 0;

          this.chartData = {
            labels: months,
            datasets: [{
              label: `Revenue - ${response.year}`,
              data: revenueData,
              backgroundColor: '#6F8CFF', 
              borderRadius: 10,
              barThickness: 30
            }]
          };

          this.cdr.detectChanges(); 
          setTimeout(() => this.updateChartGradient(), 100); 
        }
      },
      error: (err: any) => {
        console.error('Failed to load revenue chart:', err);
      }
    });
  }

  // Add this helper to get schoolId (replace with your actual logic)
  getSchoolId(): number {
    return this.schoolId;
  }

  initChart(): void {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    this.chartData = {
      labels: months,
      datasets: [{
        label: 'Revenue',
        data: new Array(12).fill(0),
        backgroundColor: '#6F8CFF',
        borderRadius: 10,
        barThickness: 30
      }]
    };

    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: (value: number) => `$${value}`,
            color: '#6c757d',
            font: { size: 12 }
          },
          grid: { color: '#e9ecef' }
        },
        x: {
          ticks: {
            color: '#6c757d',
            font: { size: 12 }
          },
          grid: { display: false }
        }
      },
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (context: any) => `$${context.parsed.y}`
          }
        }
      }
    };
  }

  updateChartGradient(): void {
    const canvas = this.chartRef?.nativeElement?.querySelector('canvas');
    if (!canvas) {
      console.warn('Canvas not available yet.');
      return;
    }

    const ctx = canvas.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, '#6F8CFF');
    gradient.addColorStop(1, '#9C84FF');

    if (this.chartData?.datasets?.[0]) {
      this.chartData.datasets[0].backgroundColor = gradient;
      this.chartData = { ...this.chartData }; 
    }
  }

  onYearChange(yearDate: Date) {
    this.selectedYear = yearDate.getFullYear();
    this.fetchAddressAndRevenue();
  }
}
